// extracted by mini-css-extract-plugin
export default {"root":"MenuLabel_root__3TkmG","clickedWithMouse":"MenuLabel_clickedWithMouse__31c0u"};